<template>
  <TemplateView>
    <div class="container">
      <TemplatePageGrid
        :items="employeeGroupGrid"
        :page-data="pageData"
        :loading="loadingAnimation"
        change-style
      >
        <template v-slot:buttons>
          <EmployeesGroupCreateAndEditModal
            v-if="
              $userCheckAccess({
                abilities: 'edit_hr',
              })
            "
            :create="true"
          />
        </template>
        <EmployeesGroupTable
          v-if="$route.query.style_list === 'table'"
          :items="employeeGroupGrid"
        />
        <div class="employeesGroupGrid" v-else>
          <EmployeesGroupListItem
            v-for="(item, key) in employeeGroupGrid"
            :key="key"
            :item="item"
          />
        </div>
      </TemplatePageGrid>
    </div>
  </TemplateView>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import TemplateView from 'components/templates/TemplateView'
import TemplatePageGrid from 'components/templates/TemplatePageGrid'
import EmployeesGroupCreateAndEditModal from 'components/employees/group/EmployeesGroupCreateAndEditModal'
import EmployeesGroupTable from 'components/employees/group/EmployeesGroupTable'
import EmployeesGroupListItem from 'components/employees/group/EmployeesGroupListItem'

export default {
  name: 'employeesGroup',
  components: {
    TemplateView,
    TemplatePageGrid,
    EmployeesGroupTable,
    EmployeesGroupCreateAndEditModal,
    EmployeesGroupListItem,
  },
  data() {
    return {}
  },
  created() {
    this.downloadPageData()
  },
  watch: {
    '$route.query'(newData, oldData) {
      if (newData.style_list === oldData.style_list) {
        this.downloadPageData()
      }
    },
  },
  computed: {
    ...mapGetters('employeeGroup', ['employeeGroupGrid', 'pageData']),
    ...mapGetters(['loadingAnimation']),
  },
  methods: {
    ...mapActions('employeeGroup', ['onEmployeeGroupGrid']),
    downloadPageData() {
      let data = {
        limit: this.$route.query.limit,
        page: this.$route.query.page,
      }
      // if (this.filterParams.length) {
      //     data.filters = this.filterParams
      // }
      if (this.$route.query.sort_param && this.$route.query.sort_value) {
        data.sort = {
          param: this.$route.query.sort_param,
          value: this.$route.query.sort_value,
        }
      }
      if (this.$route.query.search) {
        data.search = this.$route.query.search
      }
      this.onEmployeeGroupGrid(data)
    },
  },
}
</script>

<style lang="scss" scoped>
.employeesGroupGrid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 24px;
}
</style>
